interface SlickOptionsWithHandlers extends JQuerySlickOptions {
    onAfterChange?: (
        e: Event | undefined,
        slick: JQuerySlick,
        currentSlide: number,
    ) => void;
}

interface SliderConfigs {
    default: SlickOptionsWithHandlers;
    [key: string]:
        | SlickOptionsWithHandlers
        | ((element: HTMLElement) => SlickOptionsWithHandlers);
}

export class SliderHelper {
    public readonly SLIDER_CONFIGS: SliderConfigs = {
        default: {
            autoplay: false,
            autoplaySpeed: 8000,
            infinite: true,
            arrows: true,
            prevArrow:
                '<div class="slick-prev"><i class="far fa-angle-left"></i></div>',
            nextArrow:
                '<div class="slick-next"><i class="far fa-angle-right"></i></div>',
            dots: false,
            customPaging: (): string => "<button></button>",
            swipeToSlide: true,
            respondTo: "window",
            responsive: [
                // {
                //   breakpoint: 1201, // active at <= 1200px
                //   settings: {
                //     slidesToShow: 5
                //   }
                // }
            ],
        },
    };

    constructor(private slidersSelector: string) {}

    public initSliders(): void {
        this.initSimpleSliders();
        this.initNoPagenumbersSliders();
        this.initRelatedProductSlider();

        const sliders = $(this.slidersSelector);
        sliders.each((i, el) => {
            this.initSlider($(el));
        });
    }

    private initSimpleSliders(): void {
        $(".slider-simple").each((i, el) => {
            let responsive = [];
            if (typeof el.dataset.responsive === "string") {
                try {
                    responsive = JSON.parse(el.dataset.responsive);
                } catch (e) {
                    // console.log(
                    //     "unable to initialize slider responsive config",
                    //     e,
                    // );
                }
            }

            $(el).slick({
                autoplay: false,
                swipeToSlide: true,
                infinite: false,
                arrows: true,
                prevArrow:
                    '<div class="slick-prev"><i class="fas fa-arrow-left"></i></div>',
                nextArrow:
                    '<div class="slick-next"><i class="fas fa-arrow-right"></i></div>',
                dots: true,
                dotsClass: "custom_paging",
                customPaging: function (slider, i) {
                    //FYI just have a look at the object to find available information
                    //press f12 to access the console in most browsers
                    //you could also debug or look in the source
                    // console.log(slider);
                    return i + 1 + " | " + slider.slideCount;
                },
                respondTo: "window",
                responsive: responsive,
            });
        });
    }

    private initNoPagenumbersSliders(): void {
        $(".slider-no-pagenumbers").each((i, el) => {
            let responsive = [];
            if (typeof el.dataset.responsive === "string") {
                try {
                    responsive = JSON.parse(el.dataset.responsive);
                } catch (e) {
                    // console.log(
                    //     "unable to initialize slider responsive config",
                    //     e,
                    // );
                }
            }

            $(el).slick({
                autoplay: false,
                swipeToSlide: true,
                infinite: false,
                arrows: true,
                prevArrow:
                    '<div class="slick-prev"><i class="fas fa-arrow-left"></i></div>',
                nextArrow:
                    '<div class="slick-next"><i class="fas fa-arrow-right"></i></div>',
                dots: true,
                dotsClass: "no_paging",
                respondTo: "window",
                responsive: responsive,
            });
        });
    }

    private initRelatedProductSlider(): void {
        $(".related-products-slider").each((i, el) => {
            let responsive = [];
            if (typeof el.dataset.responsive === "string") {
                try {
                    responsive = JSON.parse(el.dataset.responsive);
                } catch (e) {
                    // console.log(
                    //     "unable to initialize slider responsive config",
                    //     e,
                    // );
                }
            }

            $(el).slick({
                autoplay: false,
                swipeToSlide: true,
                arrows: true,
                prevArrow:
                    '<div class="slick-prev"><span class="btn-round btn-left"></span></div>',
                nextArrow:
                    '<div class="slick-next"><span class="btn-round btn-right"></span></div>',
                dots: false,
                respondTo: "window",
                responsive: responsive,
            });
        });
    }
    // ---------------------------------------------------------------------------

    private initSlider(el: JQuery): void {
        const config = this.getConfig(el);

        if (typeof config.onAfterChange === "function") {
            el.on("afterChange", config.onAfterChange);
            el.on("init", function (e, slick) {
                config.onAfterChange(undefined, slick, 0);
            });
        }

        el.slick(config);
    }

    private getConfig(el: JQuery): SlickOptionsWithHandlers {
        const configKey = el.data("slickconfig");
        if (
            typeof configKey === "string" &&
            configKey.length > 0 &&
            configKey in this.SLIDER_CONFIGS
        ) {
            const config = this.SLIDER_CONFIGS[configKey];
            return typeof config === "function" ? config(el[0]) : config;
        }
        return this.SLIDER_CONFIGS.default;
    }
}
